module.exports = __webpack_public_path__ + "static/img/TechnicalServices.9df8489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/TechnicalServices.png
// module id = lVEm
// module chunks = 1